function addFirstKeyValueList (list, kvItem) {
  for (var i in list) {
    if (list[i].value === kvItem.value) return
  }
  list.unshift(kvItem)
}

/**
 * 置所有为-1的key为空
 * @param {obj} obj
 * @param  {...any} names
 */
function clearNullId (obj, ...names) {
  for (var n in names) {
    n = names[n]
    if (obj[n] === -1 || obj[n] === '-1') {
      obj[n] = ''
    }
  }
}
function getKeyValueList (row, valueField, textField) {
  const value = row[valueField]
  const text = row[textField]
  if (value === undefined || value === '' || value === -1 || value === '-1') return []
  else if (Array.isArray(value)) {
    const r = []
    for (let index = 0; index < value.length; index++) {
      r.push({ value: value[index], text: text[index] })
    }
    return r
  } else return [{ value: value, text: text }]
}

function arrToJson (val) {
  if (Array.isArray(val)) {
    return val.join(',') - 0
  }
  return val - 0
}

function filterObj (obj) {
  const _obj = {}
  for (const k in obj) {
    if (obj[k] !== '') {
      _obj[k] = obj[k]
    }
  }
  return _obj
}

function downLoadFile (url) {
  const link = document.createElement('a')
  link.href = url + '?' + new Date().getTime()
  document.body.append(link)
  link.click()
  document.body.removeChild(link)
}

function downLoadBinary (binary, fileName) {
  const blob = new Blob([binary])
  var link = document.createElement('a')
  link.download = fileName
  link.style.display = 'none'
  link.href = URL.createObjectURL(blob)
  // 触发点击
  document.body.appendChild(link)
  link.click()
  // 然后移除
  document.body.removeChild(link)

  // var reader = new FileReader()
  // reader.readAsDataURL(blob)
  // reader.onload = function (e) {
  //   var link = document.createElement('a')
  //   link.download = 'license.text'
  //   link.style.display = 'none'
  //   // // 字符内容转变成blob地址
  //   // var blob = new Blob([res])
  //   link.href = e.target.result
  //   // 触发点击
  //   document.body.appendChild(link)
  //   link.click()
  //   // 然后移除
  //   document.body.removeChild(link)
  // }

  // // var file = new window.File([blob], 'key.DSP', { type: 'blob' })
  // // console.log(file)
}

function getValFormKey (obj, keyArr) {
  if (obj) {
    if (keyArr && keyArr.length) {
      let data = obj[keyArr[0]]
      for (let i = 1; i < keyArr.length; i++) {
        if (data === undefined || data === null || data === '') {
          return data
        }
        data = data[keyArr[i]]
      }
      return data
    } else {
      return obj
    }
  }
  return obj
}

function isEmpty (o) {
  if (o === '' || o === undefined) return true
  else if (o.length === 0) return true
  else return false
}

function getImgBase64Url (src) {
  return new Promise((resolve, reject) => {
    const image = new Image()

    image.setAttribute('crossOrigin', 'anonymous')

    image.src = src

    image.onload = () => {
      var canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      var context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, image.width, image.height)

      var dataURL = canvas.toDataURL('image/jpeg')

      resolve(dataURL)
    }

    image.onerror = (err) => {
      console.log(err)
      // eslint-disable-next-line prefer-promise-reject-errors
      reject('图片加载失败!')
    }
  })
}

function getTime (type, seconds) {
  let h = 0
  let m = parseInt(seconds / 60)
  let s = seconds % 60
  s = s < 10 ? `0${s}` : s

  if (type === 'h') {
    h = parseInt(m / 60)
    m = m - h * 60

    h = h < 10 ? `0${h}` : h
    m = m < 10 ? `0${m}` : m
    return `${h} : ${m} : ${s}`
  }
  if (type === 'm') {
    m = m < 10 ? `0${m}` : m
    return `${m}:${s}`
  }
}

function getFontColor (type) {
  const color = type === 1 ? 'cg' : type === 2 ? 'xb' : type === 3 ? 'bd' : ''
  return `check_type ${color}`
}

function sortDateTime (a, b, key) {
  const time1 = a[key] ? Date.parse(a[key]) : 0
  const time2 = b[key] ? Date.parse(b[key]) : 0
  return time1 - time2
}

function getID (length) {
  return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36)
}

export default {
  addFirstKeyValueList,
  isEmpty,
  clearNullId,
  getKeyValueList,
  arrToJson,
  filterObj,
  downLoadFile,
  downLoadBinary,
  getValFormKey,
  getImgBase64Url,
  getTime,
  getFontColor,
  sortDateTime,
  getID
}
